
<div class="row">
  <div class="columns">
    <gw-templates-group class="templates-list__group" [templates]="templates" (templateUpdated)="onUpdateTemplate()" (templateRemoved)="onRemoveTemplate()" (auditCreated)="loadAuditsAmount()"></gw-templates-group>
    <gw-pagination class="templates-list__pagination" *ngIf="totalTemplates" [totalElementsAmount]="totalTemplates" [currentPage]="filterService?.page" [currentLimit]="filterService?.limit" (changePage)="changePage($event)" (changeLimit)="changeLimit($event)"></gw-pagination>
  </div>
</div>